import clsx from 'clsx';
import React, { useState } from 'react';
import type { SVGProps } from 'react';

import Button, { ButtonProps } from '../index';

type StatusButtonProps = ButtonProps & {
  as: 'button';
  statusText: {
    active: string;
    inverse: string;
  };
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
};

const StatusButton = ({
  children: defaultText,
  className,
  icon: Icon,
  onClick,
  statusText,
  ...rest
}: StatusButtonProps) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <Button
      className={clsx(
        className,
        'group flex justify-between gap-10 border-solid px-24 py-6 font-suisse-intl-mono text-button-md text-black transition-colors focus:outline-none focus-visible:ring-4',
        {
          'border-black bg-white hover:border-primary-pink hover:bg-primary-pink hover:text-primary-magenta':
            !isActive,
          'border-grayscale-beige bg-grayscale-beige': isActive,
        }
      )}
      onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setIsActive((isActive) => !isActive);
        onClick(e);
      }}
      {...rest}
    >
      {isActive ? (
        <>
          <span aria-hidden>
            <Icon className="w-[15px] fill-current" />
          </span>
          <span className="group-hover:hidden group-focus-visible:hidden" aria-hidden>
            {statusText.active}
          </span>
          <span className="hidden group-hover:inline group-focus-visible:inline">
            {statusText.inverse}
          </span>
        </>
      ) : (
        defaultText
      )}
    </Button>
  );
};

export default StatusButton;
